import React from "react";
import styles from "./AuthFlowLoader.module.css";

// Keeping track of menu expansion and loader visibility
import { useSelector } from "react-redux";
import { selectLoaderProcesses } from "../../redux/features/applicationState/applicationStateSlice";

const AuthFlowLoader = () => {
  const loaderProcesses = useSelector(selectLoaderProcesses);

  const loaderClassName = `
  ${styles["loader-container"]}`;

  return (
    <div
      className={loaderClassName}
      style={
        loaderProcesses > 0
          ? { transform: "translateY(0)" }
          : { transform: "translateY(25vw)" }
      }
    >
      <div className={styles["loader"]}></div>
    </div>
  );
};

export default AuthFlowLoader;
